import { render, staticRenderFns } from "./MovementsItemDetail.vue?vue&type=template&id=1324cd9c"
import script from "./MovementsItemDetail.vue?vue&type=script&lang=js"
export * from "./MovementsItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports